import { AddHomeVideoReviewActionsProps as BaseAddHomeVideoReviewActionsProps } from "@bluframe/mightychroma-mightytool-frontend-types"

import AddActions from "./AddActions"

export interface Props extends BaseAddHomeVideoReviewActionsProps {}

export interface ComponentProps extends Props {}

export default AddActions
